var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('regulation-item',{attrs:{"regulationItemsProps":_vm.regulationItems,"destroyRegulationItemsProps":_vm.destroyRegulationItems,"editingRegulationBundler":_vm.editingRegulationBundler}})}
var staticRenderFns = []

export { render, staticRenderFns }